// extracted by mini-css-extract-plugin
module.exports = {"report_item":"styles_report_item__mmv48","report_item_text":"styles_report_item_text__2Ij30","report_item_data":"styles_report_item_data__1wO7F","history":"styles_history__1li-f"};